import { Family } from '../types/family';
import { ScheduledPatch } from '../types/shared';

/** Uveljavi spremembo na podatkih ene družine. Zaključeni tedni ostanejo zapisani v WeekClose. */
export function applyPatch(f: Family, p: ScheduledPatch): Family {
  if (p.target === 'rules') {
    const prev = f.rules;
    const rules = { ...prev, ...p.patch };
    const templates = f.templates.map((t) => {
      if (p.patch.readingMinutes !== undefined && t.planKey === 'branje') return { ...t, targetMinutes: rules.readingMinutes };
      if (p.patch.sportMinutes !== undefined && t.planKey === 'sport') return { ...t, targetMinutes: rules.sportMinutes };
      if (p.patch.roomBonus !== undefined && t.group === 'hisa' && t.valueType === 'bonus') return { ...t, baseValue: rules.roomBonus };
      if (
        p.patch.houseCategoryValue !== undefined &&
        t.group === 'hisa' &&
        !t.planKey &&
        t.frequency?.kind === 'tedensko' &&
        t.baseValue === prev.houseCategoryValue
      )
        return { ...t, baseValue: rules.houseCategoryValue };
      return t;
    });
    return { ...f, rules, templates };
  }
  if (p.target === 'template') {
    return { ...f, templates: f.templates.map((t) => (t.id === p.id ? { ...t, ...p.patch } : t)) };
  }
  return { ...f, rewards: f.rewards.map((r) => (r.id === p.id ? { ...r, ...p.patch } : r)) };
}
